import { render } from "./OAuthCallback.vue?vue&type=template&id=a6ed215a&scoped=true"
import script from "./OAuthCallback.vue?vue&type=script&lang=js"
export * from "./OAuthCallback.vue?vue&type=script&lang=js"

import "./OAuthCallback.vue?vue&type=style&index=0&id=a6ed215a&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6ed215a"]])

export default __exports__